import DEFAULT_MASKED_LOG_FIELDS from '../consts/default-masked-log-fields';
import { stringMatchesArrayIgnoreCase } from './array-functions';
// Masks fields in the fieldsToMask array by replacing their values with '**'
// An empty fieldsToMask array indicates that all fields should be masked
export var maskFieldsForLogging = function (logObj, fieldsToMask) {
    try {
        Object.keys(logObj).forEach(function (field) {
            // eslint-disable-next-line eqeqeq
            if (logObj[field] != undefined) {
                if (typeof logObj[field] === 'object') {
                    logObj[field] = maskFieldsForLogging(logObj[field], fieldsToMask);
                }
                else if (stringMatchesArrayIgnoreCase(fieldsToMask, field) ||
                    fieldsToMask.length === 0) {
                    logObj[field] = '**';
                }
            }
        });
        return logObj;
    }
    catch (e) {
        return 'REDACTED';
    }
};
export var maskDefaultFieldsForLogging = function (logObj) {
    return maskFieldsForLogging(logObj, DEFAULT_MASKED_LOG_FIELDS);
};
